import script from "./WorkHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkHistory.vue?vue&type=script&setup=true&lang=js"

import "./WorkHistory.vue?vue&type=style&index=0&id=1e57ae1f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e57ae1f"]])

export default __exports__